import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Separator } from '@wartek-id/separator'

import { assetUrl } from 'utils/url'

import type { FC } from 'react'

type EvaluationResultHeaderProps = {
  title: string
}

const EvaluationResultHeader: FC<EvaluationResultHeaderProps> = ({ title }) => {
  return (
    <>
      <section className="flex flex-row items-center gap-6">
        <div className="flex flex-row gap-3 flex-none h-11 items-center">
          <Image
            alt="Logo Tut Wuri Handayani"
            src="/images/kemendikbud2x.png"
            width={40}
            height={40}
          />

          <img
            src={assetUrl('/icon/e-pengelolaan-kinerja-logo.png')}
            width={124}
            height={32}
            className="max-h-full w-auto h-8"
            alt=""
          />
        </div>

        <div className="flex-1">
          <Text as="span" variant="heading-md">
            {title}
          </Text>
        </div>

        <Button
          size="lg"
          color="blue"
          className="space-x-1 print:!hidden"
          onClick={() => window.print()}
        >
          <Icon color="inherit">print_outlined</Icon> <span>Cetak</span>
        </Button>
      </section>

      <Separator />
    </>
  )
}
export default EvaluationResultHeader
